import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronSelectorVerticalIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.24408 12.4107C5.56951 12.0853 6.09715 12.0853 6.42259 12.4107L10 15.9882L13.5774 12.4107C13.9028 12.0853 14.4305 12.0853 14.7559 12.4107C15.0814 12.7362 15.0814 13.2638 14.7559 13.5893L10.5893 17.7559C10.2638 18.0814 9.73618 18.0814 9.41074 17.7559L5.24408 13.5893C4.91864 13.2638 4.91864 12.7362 5.24408 12.4107Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.24408 8.58926C5.56951 8.91469 6.09715 8.91469 6.42259 8.58926L10 5.01184L13.5774 8.58926C13.9028 8.91469 14.4305 8.91469 14.7559 8.58926C15.0814 8.26382 15.0814 7.73618 14.7559 7.41074L10.5893 3.24408C10.2638 2.91864 9.73618 2.91864 9.41074 3.24408L5.24408 7.41074C4.91864 7.73618 4.91864 8.26382 5.24408 8.58926Z"
	})]
});
export default SvgChevronSelectorVerticalIcon;
